// CategoryGroup.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import CategoryItem from '../component/CategoryItem.jsx';

import { TranslationNamespace } from '../resource/translationNamespace.js';

import media from '../style/media.js';

const CategoryGroup = ({
  t,
  i18n,
  title = '',
  groupName,
  categoryItems = [],
  selectedCategoryItems = [],
  onStatusChange,
  isInOverview = false,
}) => {
  let categoryTitle = title;
  if (groupName) {
    const i18nKey = `category_grouping_${groupName}`;
    const isTranslationExisted = i18n.customExists(i18nKey, {
      ns: TranslationNamespace.POST,
    });
    categoryTitle = isTranslationExisted
      ? t(i18nKey, { ns: TranslationNamespace.POST })
      : groupName;
  }

  if (!categoryItems.length) return null;

  return (
    <Container>
      <Header>{categoryTitle}</Header>
      <Body as={isInOverview ? 'nav' : 'div'}>
        {categoryItems.map(item =>
          isInOverview ? (
            <CategoryItem
              key={item}
              categoryId={item}
              isLink={true}
              isInOverview={true}
            />
          ) : (
            <CategoryItem
              key={item}
              categoryId={item}
              isSelectable={true}
              selected={selectedCategoryItems.includes(item)}
              onStatusChange={onStatusChange}
            />
          )
        )}
      </Body>
    </Container>
  );
};

CategoryGroup.propTypes = {
  t: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired,
  title: PropTypes.string,
  groupName: PropTypes.string,
  categoryItems: PropTypes.array,
  selectedCategoryItems: PropTypes.array,
  onStatusChange: PropTypes.func,
  isInOverview: PropTypes.bool,
};

const Container = styled.div`
  :not(:last-child) {
    margin-bottom: 24px;

    ${media.mobile`
      margin-bottom: 20px;
    `};
  }
`;

const Header = styled.div`
  color: var(--font-color-primary-on-dark, #fff);
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  ${media.mobile`
    font-size: 16px;
  `};

  margin-bottom: 8px;
`;

const Body = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

export default withTranslation()(CategoryGroup);
